import { JsonObject, JsonProperty } from 'json2typescript'

@JsonObject('GoCardlessDetails')
export default class GoCardlessDetails {
  @JsonProperty('preferredPaymentDay', Number)
  preferredPaymentDay = 0
}
